import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import 'vuetify/styles';
import { ThemeDefinition, createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const myCustomLightTheme: ThemeDefinition = {
    dark: false,
    colors: {
        primary: '#0D47A1',
        secondary: '#9ccc65',
        'on-secondary': '#FFFFFF',
        background: '#E8EAF6',
        surface: '#FFFFFF'
    }
};

export const vuetify = createVuetify({
    theme: {
        defaultTheme: 'myCustomLightTheme',
        themes: {
            myCustomLightTheme
        }
    },
    components,
    directives,
    defaults: {
        VTextField: { variant: 'underlined' },
        VSelect: { variant: 'underlined' },
        VDataTable: {
            mobileBreakpoint: 'sm' // Ab 600 px wird mobile Ansicht dargestellt
        },
        VDataTableServer: {
            mobileBreakpoint: 'sm'
        }
    }
});
